<template>
	<div v-if="retentionCheck.sellWithRetention" class="flex text_left margin_top">
		<md-checkbox style="margin-top: 5px;"
					 :class="[{ 'md-error': errors.has(validationName) }]"
					 v-model="value"
					 v-validate="validationRules"
					 :data-vv-name="validationName"
					 :required="validationRules.checked"
		/>
		<span>
      		<span v-html="$t(retentionCheck.textParams.textKey, retentionCheck.textParams)"></span>
			<span v-if="validationRules.checked">*</span>
			<span v-if="errors.has(validationName)" class="validation-error validation-inline">
				{{ errors.first(validationName) }}
			</span>
			<el-tooltip v-if="retentionCheck.textParams.tooltipKey" placement="top" style="margin-left: 5px">
				<span slot="content" v-html="$t(retentionCheck.textParams.tooltipKey, retentionCheck.textParams)"></span>
				<i class="fa fa-info-circle secondary_color" aria-hidden="true"></i>
			</el-tooltip>
    </span>
	</div>
</template>

<script>
import {retentionCheckApi} from "@/common/api/retentionCheckApi";
import {formatAsPercentage} from "@/common/format";
import {Validator} from "vee-validate";

export default {
	props: {
		value: { type: Boolean, default: false },
		debtorId: { type: [Number, null], default: null },
		validationRules: { type: Object, default: { checked: false} },
		validator: { type: Validator, required: true }, // Parent validator instance since the default Vue inject mechanism leads to problems with the modal this is embedded in
		isMultiple : { type: Boolean, default: false },
	},
	data() {
		return {
			validationName: "sellWithRetention",
			retentionCheck: {
				sellWithRetention: false,
				termsAndConditionsUrl: null,
				retentionRate: null,
				textParams: {
					textKey: null,
					tooltipKey: null,
					url: null,
					retentionInPercent: null
				}
			}
		};
	},
	created() {
		// Update the internal validator instance
		this.$validator = this.validator;
	},
	methods: {
		updateRetentionCheck() {
			retentionCheckApi.checkRetention({ debtorId: this.debtorId })
				.then(res => {
					this.retentionCheck = {
						...res,
						textParams: {
							textKey: this.isMultiple ? "seller.upload.retention.mandatory.check.plural" : "seller.upload.retention.mandatory.check.single",
							tooltipKey: null,
							url: res.termsAndConditionsUrl,
							retentionInPercent: formatAsPercentage(res.retentionRate, { decimals: 0 })
						}
					};

					if (res.sellWithRetention) {
						// User must confirm retention if it is required
						this.validationRules.checked = true;
					} else {
						// User must NOT confirm retention if it is NOT required
						this.validationRules.checked = false;

						// If retention is not set for the seller, automatically remove any checks to avoid validation problems
						this.updateValue(false);
					}

					this.$emit("update", this.retentionCheck);
				})
				.catch(this.toast);
		},
		updateValue(value) {
			this.value = value;
			this.$emit("input", value);
		}
	},
	watch: {
		debtorId: {
			handler() {
				this.updateRetentionCheck();
			},
			immediate: true
		},
		value() {
			this.$emit("input", this.value);
		}
	},
};
</script>